export enum AdminRoles {
	GENERAL = 'General',
	FINANCIAL = 'Financial',
	CONTENT = 'Content',
}
